/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type AddItemToHardwareRequestMutationVariables = Types.Exact<{
  hardware_request_id: Types.Scalars["Float"];
  hardware_item_id: Types.Scalars["Float"];
  quantity: Types.Scalars["Float"];
}>;

export type AddItemToHardwareRequestMutation = {
  addItemToHardwareRequest: Pick<
    Types.HardwareItemRequest,
    "id" | "hardware_request_id" | "hardware_item_id" | "quantity"
  >;
};

export const AddItemToHardwareRequestDocument = gql`
  mutation AddItemToHardwareRequest(
    $hardware_request_id: Float!
    $hardware_item_id: Float!
    $quantity: Float!
  ) {
    addItemToHardwareRequest(
      hardware_request_id: $hardware_request_id
      hardware_item_id: $hardware_item_id
      quantity: $quantity
    ) {
      id
      hardware_request_id
      hardware_item_id
      quantity
    }
  }
`;

/**
 * __useAddItemToHardwareRequestMutation__
 *
 * To run a mutation, you first call `useAddItemToHardwareRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToHardwareRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToHardwareRequestMutation, { data, loading, error }] = useAddItemToHardwareRequestMutation({
 *   variables: {
 *      hardware_request_id: // value for 'hardware_request_id'
 *      hardware_item_id: // value for 'hardware_item_id'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddItemToHardwareRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddItemToHardwareRequestMutation,
    AddItemToHardwareRequestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    AddItemToHardwareRequestMutation,
    AddItemToHardwareRequestMutationVariables
  >(AddItemToHardwareRequestDocument, baseOptions);
}
export type AddItemToHardwareRequestMutationHookResult = ReturnType<
  typeof useAddItemToHardwareRequestMutation
>;
export type AddItemToHardwareRequestMutationResult =
  ApolloReactCommon.MutationResult<AddItemToHardwareRequestMutation>;
export type AddItemToHardwareRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddItemToHardwareRequestMutation,
    AddItemToHardwareRequestMutationVariables
  >;
